import React from "react";

class WrapperComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.log(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="text-center">
          <h4>
            Something Bad Happened <i className="fas fa-bomb" />
          </h4>
        </div>
      );
    }

    return this.props.children;
  }
}

export default WrapperComponent;
